import { BaseSettings, BaseThemeType } from 'Shared/frontend/themes/BaseSettings';
import { merge } from 'Shared/common/merge';
import { DeepPartial } from 'Shared/frontend/SettingsProvider';
import { OpenSans } from 'Shared/frontend/fonts/OpenSans';
import { Questrial } from '../fonts/Questrial';
import { Oswald } from 'Shared/frontend/fonts/Oswald';
import { INav } from 'Common/config/INav';
import { lazy } from 'solid-js';
import { fluidType } from 'Shared/common/FluidType';
import { Contact } from 'Shared/frontend/icons/Contact';
import {Calendar} from 'Shared/frontend/icons/Calendar';
import {FoodMenu} from 'Shared/frontend/icons/FoodMenu';
import {Home} from 'Shared/frontend/icons/Home';

import {PeopleCircle} from 'Shared/backend/icons/PeopleCircle'; 


export class ChippoSettings extends BaseSettings
{
	palette()
	{
		return{
			background: '#ffffff',
			text: '#000000',
			inverseText: '#ffffff',
			feature: '#83b0c3', //Sky blue //'#135864', // Logo Blue
			feature2: '#f8b30e', // Sun Yellow
			feature3: '#83b0c3', //Sky blue

			/* Eg the mobile nav colour */
			dimBackground: '#83b0c3', //Skyblue again

			food: '', 
			drinks: '',
			
		};
	}

	fontIncludes()
	{
		return [
			OpenSans,
			Questrial,
			Oswald 
//			Alatsi,
		];
	}

	fontsText()
	{
		return({
			fontFamily: '"Questrial", serif',
			fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,18),		
		})
	}

	fontsHeading()
	{
		return({
			fontFamily: '"Oswald", sans-serif',
			letterSpacing: 3,
			lineHeight: 1.2,
			fontWeight: '400',
			color: this.palette().feature2,	
		
		})
	}

	fontsHeading2()
	{
		return({
			fontFamily: '"Questrial", sans-serif',
			color: this.palette().feature2,	
			fontWeight: '300',
			lineHeight: 1,		
		})
	}

	fontsHeading3()
	{
		return({
			fontFamily: '"Oswald", sans-serif',
			letterSpacing: 3,
			lineHeight: 1.2,
			fontWeight: '400',
			color: this.palette().feature,	
		})
	}
	
	fonts()
	{
		return {
			text: '"Questrial", sans-serif',
			heading: '"Oswald", sans-serif',
			subNav: '"Questrial", sans-serif',
			buttons: '"Questrial", sans-serif',
			desktopNav: '"Oswald", sans-serif',
			mobileNav: '"Oswald", sans-serif',
		};
	}

	//used on Teaser,Title,Tagline so they layout evenly and collapse when needed
	textMargins()
	{
		return({
			margin: '.3em 0',
		})
	}

	//For consistency on all navs inc sticky subs, hire, home, event lineups
	subNavButtons()
	{
		return({
			backgroundColor: this.palette().feature2,
			color: this.palette().background,
			borderRadius: '0.4em',
			fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,15,20),
		})
	}

	text()
	{
		return merge(super.text(), {
			
			pageTitle: {
				...this.fontsHeading(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,30,50),
				textTransform: 'uppercase',
		
			},
			plain: {
				...this.fontsText(),
			},
			title: {
				...this.fontsHeading(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,30,50),
				textTransform: 'uppercase',
				...this.textMargins(),
			},
			subtitle: {
				...this.fontsHeading3(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,25,45),
				
			},
			teaser: {
				...this.fontsHeading(),
				...this.textMargins(),
				//textTransform: 'uppercase',
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,22,36),
			},
			tagline: {
				...this.fontsHeading3(),
				...this.textMargins(),
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,22,36),	
			},

		});
	}

	poster()
	{
		return merge(super.poster(), {
			shared: {
				root: {
					backgroundColor: this.palette().feature3,
					//...this.fontsHeading(),
					fontSize: '16px',
					lineHeight: 1.1,
					color: this.palette().inverseText,
					
				},
				dateBar: {
					backgroundColor: this.palette().feature3,
					...this.fontsText(),
					fontSize: '16px',
					color: this.palette().inverseText,
					
				},

				imageWrap:{
					img:{
						borderTopLeftRadius: 80,
						borderBottomRightRadius: 80,
					},
				},
				/*Overlapping Bens development version
				types: {
					overlapping: {
						name:{
							textTransform: 'initial !important',
						},
						eventTagline:{
							fontSize: '.8em !important'
						}
					},
				},
				*/
			},
		});
	}

	page()
	{
		return merge(super.page(),{

			body: {
				...this.fontsText(),
			},

			heading: {
				color: this.palette().feature,
			},
			
			section: {},

			button: {
				backgroundColor: this.palette().feature,
				borderRadius: '0.4em',
				color: this.palette().background,
				fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,20),
			},

			widgets: {

				scrollStyle:{
					scrollbarColor: 'white #ced6dc !important',
				},
				overlay: {

					'.text-teaser':{
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,24,32),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,		
					},
					'.text-title': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,44,64),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,
					},
					'.text-subtitle': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,36,60),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,
					},
					'.text-tagline': {
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,24,36),
						fontWeight: '300',
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,
					},

					'.text-plain': {
						//fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,20,64),
						textShadow: '0 0 5px black',
						color: this.palette().inverseText,
					},
					
					button: {
						backgroundColor: this.palette().inverseText,
						borderRadius: '0.4em',
						color: this.palette().feature,
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,16,20),
					},
				},
				subNav: {
					button: {
						...this.subNavButtons(),
					}
				},
			},
		});
	}
//navigation
	//navigation settings
	nav()
	{
		const palette = this.palette();
		return merge(super.nav(),{
			
			desktop:{
				type: 'standard',
				
				settings: {
					fadeBackgroundIn: false, 
					outer: {background: palette.feature3,},
					
					logo:{
						padding: '10px 0px',
					},	
					button: {
						...this.fontsHeading(),
						color: palette.inverseText,
						fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,14,25),
				
					},
				
					active: {
						color: palette.feature2,
					},


					hover: {
						color: palette.feature2,
					},

					
				}
			},

			mobile:{		
				overlay:{background: palette.feature3},
		
				button:{
					color: palette.inverseText,
					background: palette.feature3,

					// Ask ben need to do importants to overwrite SVG formula on MobileFooter Nav
					//search fill: isActive ? theme().nav.mobile.active.color : palette().text
					svg:{
						fill: `${palette.inverseText} !important`
					},

					':hover': {
					//TODO cf remove from BaseTheme?						
						backgroundColor: this.palette().feature,
					}
				},
				active: {
					color: palette.feature2,
					svg:{
						fill: `${palette.feature2} !important`
					},
				},
				more: {
					root: {
						backgroundColor: palette.feature3,

					},
					button: {
						':hover': {
							color: this.palette().inverseText,
							backgroundColor: this.palette().feature,
						}
					}
				}
			},

		})
	}

	siteTheme()
	{
		const base = super.siteTheme();
		const palette = this.palette();

		base.specials = {
			general: 'General',
			beers: 'Beers'
		};

		const settings = merge(base, <DeepPartial<BaseThemeType>>{

			event: {
				subNav: {
					button:{
						...this.subNavButtons(),
					}
				},

				heading: {
					...this.fontsHeading2(),
					fontSize: '2em',
					lineHeight: 1.1,
					textTransform:'uppercase',
					color: palette.feature
				},
				artist: {
					heading: {
						color: palette.feature2,
					},
					wide: {
						nameAndTime: {
							color: palette.feature
						}
					},
					narrow: {
						nameAndTime: {
							backgroundColor: palette.feature,
						}
					}, 
					genresAndLocation: {
						color: palette.feature2
					} 
				}
			},

			//TODO share most of this with the townie. eg 'ColouredDarkTheme' parent
			menu: {
				subNav: {
					button: {
						...this.subNavButtons(),
					},
		
				},
				section: {
					marginBottom: '3em'
				},
				item: {
					type: 'imageless',
					title: { 
					...this.fontsText(),
					fontSize: fluidType('px',this.sizes().endFontShrink,this.sizes().minDesktopWidth,18,25),	
					
					},
				},
			},

			subNavButton: {
				borderRadius: '0.4em'
			},
		});
		// XXX if we want to entirely remove or overwrite a base setting or two then do so here 
		return settings;
	}

	pages()
	{
		return [
			{
				key: 'home',
				frontend: {
					route: '/',
					metaTitle: 'Home'
				},
				backend: {
					route: '/home',
					title: 'Home'
				}
			},
			{
				key: 'events',
				frontend: {
					route: '/events',
					metaTitle: 'Events'
				},
				backend: {
					route: '/events-design',
					title: 'Events'
				}
			},
			{
				key: 'book',
				frontend: {
					route: '/book',
					metaTitle: 'Book'
				},
				backend: {
					route: '/book',
					title: 'Book'
				}
			},
			{
				key: 'hire',
				frontend: {
					route: '/hire',
					metaTitle: 'Hire'
				},
				backend: {
					route: '/hire',
					title: 'Hire'
				}
			},
			{
				key: 'contact',
				frontend: {
					route: '/contact',
					metaTitle: 'Contact'
				},
				backend: {
					route: '/contact',
					title: 'Contact'
				}
			},
		];
	}

	navContent(): INav
	{
		return {
			desktop: [
				{label:'Home',		link:'frontend/Home'},
				{label:'Menu',		link:'frontend/Menu'},
				{label:'Events',	link:'frontend/Events'},
				{label:'Hire',		link:'frontend/Hire'},
				{label:'Contact',	link:'frontend/Contact'}
			],
			mobile: {
				maxButtons: 5,
				includeMoreButton: true,
				links: [
					{label:'Home',		link:'frontend/Home',		icon: Home},
					{label:'Menu',		link:'frontend/Menu',		icon:FoodMenu},
					{label:'Events',	link:'frontend/Events',		icon: Calendar},
					{label:'Hire',		link:'frontend/Hire', 		icon: Contact},
					{label:'Contact',	link:'frontend/Contact',	icon: Contact},
				]
			}
		};
	}

	routes()
	{
		return class extends super.routes() {
			frontendContent()
			{
				return [
					...super.frontendContent(),
					
				];
			}
		};
	}
}

